import React, { useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';

function Frontend() {
    const navigate = useNavigate();
    const [bal, setBal] = useState("");
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [activeMenu, setActiveMenu] = useState('dashboard');

    const navTo = (path) => {
        navigate(path);
        setActiveMenu(path.replace('/', ''));
        setSidebarOpen(false);
    }

    const logout = () => {
        localStorage.clear();
        navigate("/login");
    }

    useEffect(() => {        
        const fetchData = async () => {
            const userid = localStorage.getItem('userid');
            try {
                const res = await axios.get(`https://singlewindowsecurities.com/Rest3/wallet_api/${userid}`);
                setBal(res.data.wallet);
            } catch (error) {
                console.error("Error fetching wallet balance:", error);
            }
        };

        fetchData();
    }, []);

    return (
        <div className="app-container" style={{ 
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 50%, #0d0d0d 100%)'
        }}>
            <Helmet>
                <title>Single Window Securities - MCX Trading</title>
                <meta name="viewport" content="width=device-width, initial-scale=1" />
            </Helmet>

            {/* App Header - Dark Golden Theme */}
            <header style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                height: '60px',
                background: 'rgba(10, 10, 10, 0.95)',
                backdropFilter: 'blur(10px)',
                borderBottom: '1px solid rgba(212, 175, 55, 0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 16px',
                zIndex: 1000
            }}>
                <div className="header-left">
                    <button 
                        className="menu-button"
                        onClick={() => setSidebarOpen(true)}
                        style={{
                            background: 'rgba(212, 175, 55, 0.1)',
                            border: '1px solid rgba(212, 175, 55, 0.3)',
                            borderRadius: '12px',
                            width: '40px',
                            height: '40px',
                            color: '#D4AF37',
                            cursor: 'pointer'
                        }}
                    >
                        <i className="fas fa-bars"></i>
                    </button>
                </div>
                <div className="header-title">
                    <Link to="/dashboard">
                        <img width="300px" src="https://singlewindowsecurities.com/assets/images/logo.png" alt="Logo" />
                    </Link>
                </div>
                <div className="header-right">
                    <Link to="/settings" style={{
                        display: 'block',
                        borderRadius: '50%',
                        border: '2px solid #D4AF37'
                    }}>
                        <img src={"https://ui-avatars.com/api/?rounded=true&background=D4AF37&color=000&name="+localStorage.getItem('name')+"&size=40"} alt="User Icon" />
                    </Link>
                </div>
            </header>

            {/* Main Content */}
            <main className="app-content" style={{ marginTop: '60px', marginBottom: '70px', padding: '16px' }}>
                <Outlet />
            </main>

            {/* Sidebar - Dark Golden Theme */}
            <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} 
                onClick={() => setSidebarOpen(false)} 
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(0, 0, 0, 0.7)',
                    zIndex: 1100,
                    display: sidebarOpen ? 'block' : 'none'
                }}>
            </div>
            <aside className={`app-sidebar ${sidebarOpen ? 'active' : ''}`} style={{
                position: 'fixed',
                top: 0,
                left: -300,
                width: '280px',
                height: '100%',
                background: '#0a0a0a',
                borderRight: '1px solid rgba(212, 175, 55, 0.2)',
                zIndex: 1101,
                transition: 'left 0.3s ease',
                left: sidebarOpen ? 0 : -300
            }}>
                <div className="sidebar-header" style={{
                    padding: '20px',
                    borderBottom: '1px solid rgba(212, 175, 55, 0.2)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div className="profile-info" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img src={"https://ui-avatars.com/api/?rounded=true&background=D4AF37&color=000&name="+localStorage.getItem('name')+"&size=45"} alt="User Icon" />
                        <div className="profile-details">
                            <strong style={{ color: '#D4AF37', display: 'block' }}>{localStorage.getItem('name')}</strong>
                            <span style={{ color: '#888', fontSize: '12px' }}>Client ID #000{localStorage.getItem('userid')}</span>
                        </div>
                    </div>
                    <button 
                        className="close-sidebar"
                        onClick={() => setSidebarOpen(false)}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#D4AF37',
                            fontSize: '20px',
                            cursor: 'pointer'
                        }}
                    >
                        <i className="fa fa-times"></i>
                    </button>
                </div>

                <div className="sidebar-balance" style={{
                    padding: '20px',
                    margin: '16px',
                    background: 'linear-gradient(145deg, #D4AF37, #B8960C)',
                    borderRadius: '16px',
                    textAlign: 'center'
                }}>
                    <div className="balance-title" style={{ color: '#000', fontSize: '12px', letterSpacing: '1px' }}>WALLET BALANCE</div>
                    <div className="balance-amount" style={{ color: '#000', fontSize: '28px', fontWeight: 'bold' }}>₹{bal}</div>
                </div>

                <nav className="sidebar-menu">
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        <li>
                            <button onClick={() => navTo('/bank')} className="menu-item" style={{
                                width: '100%',
                                padding: '14px 20px',
                                background: 'none',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                color: '#fff',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)'}
                            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}>
                                <div className="menu-icon" style={{ width: '24px', color: '#D4AF37' }}>
                                    <i className="fas fa-building"></i>
                                </div>
                                <span>Bank Details</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navTo('/company')} className="menu-item" style={{
                                width: '100%',
                                padding: '14px 20px',
                                background: 'none',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                color: '#fff',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)'}
                            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}>
                                <div className="menu-icon" style={{ width: '24px', color: '#D4AF37' }}>
                                    <i className="fas fa-info-circle"></i>
                                </div>
                                <span>About Company</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={() => navTo('/contact')} className="menu-item" style={{
                                width: '100%',
                                padding: '14px 20px',
                                background: 'none',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                color: '#fff',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)'}
                            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}>
                                <div className="menu-icon" style={{ width: '24px', color: '#D4AF37' }}>
                                    <i className="fas fa-comment"></i>
                                </div>
                                <span>Contact us</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={logout} className="menu-item" style={{
                                width: '100%',
                                padding: '14px 20px',
                                background: 'none',
                                border: 'none',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '12px',
                                color: '#fff',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(212, 175, 55, 0.1)'}
                            onMouseLeave={(e) => e.currentTarget.style.background = 'none'}>
                                <div className="menu-icon" style={{ width: '24px', color: '#D4AF37' }}>
                                    <i className="fas fa-sign-out-alt"></i>
                                </div>
                                <span>Log out</span>
                            </button>
                        </li>
                    </ul>
                </nav>
            </aside>

            {/* Bottom Navigation - Dark Golden Theme */}
            <nav className="bottom-nav" style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                height: '65px',
                background: 'rgba(10, 10, 10, 0.95)',
                backdropFilter: 'blur(10px)',
                borderTop: '1px solid rgba(212, 175, 55, 0.3)',
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                zIndex: 1000
            }}>
                <Link 
                    to="/dashboard" 
                    className={`nav-item ${activeMenu === 'dashboard' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('dashboard')}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: activeMenu === 'dashboard' ? '#D4AF37' : '#666',
                        transition: 'color 0.3s ease'
                    }}
                >
                    <i className="fas fa-home" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '10px', marginTop: '4px' }}>WATCHLIST</span>
                </Link>
                <Link 
                    to="/orders" 
                    className={`nav-item ${activeMenu === 'orders' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('orders')}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: activeMenu === 'orders' ? '#D4AF37' : '#666',
                        transition: 'color 0.3s ease'
                    }}
                >
                    <i className="fas fa-list" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '10px', marginTop: '4px' }}>MCX</span>
                </Link>
                <Link 
                    to="/forex" 
                    className={`nav-item ${activeMenu === 'funds' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('funds')}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: activeMenu === 'funds' ? '#D4AF37' : '#666',
                        transition: 'color 0.3s ease'
                    }}
                >
                    <i className="fa fa-rupee-sign" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '10px', marginTop: '4px' }}>FOREX</span>
                </Link>
                <Link 
                    to="/tradebook" 
                    className={`nav-item ${activeMenu === 'tradebook' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('tradebook')}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: activeMenu === 'tradebook' ? '#D4AF37' : '#666',
                        transition: 'color 0.3s ease'
                    }}
                >
                    <i className="fa fa-book" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '10px', marginTop: '4px' }}>TRANSACTIONS</span>
                </Link>
                <Link 
                    to="/settings" 
                    className={`nav-item ${activeMenu === 'settings' ? 'active' : ''}`}
                    onClick={() => setActiveMenu('settings')}
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: activeMenu === 'settings' ? '#D4AF37' : '#666',
                        transition: 'color 0.3s ease'
                    }}
                >
                    <i className="fa fa-cog" style={{ fontSize: '20px' }}></i>
                    <span style={{ fontSize: '10px', marginTop: '4px' }}>ACCOUNT</span>
                </Link>
            </nav>
        </div>
    );
}

export default Frontend;